// src/components/Projects.js
import React from 'react';
import './Projects.css';

const Projects = () => {
  const projects = [
    {
      title: 'Credit Card Fraud Detection System',
      description: 'Built an ML-powered fraud detection system using Python, achieving high accuracy in identifying fraudulent transactions. Implemented feature engineering and model optimization techniques.',
      tech: 'Python, NumPy, Pandas, Scikit-learn',
      link: 'https://github.com/avidesai0110/Credit_Card_Fraud',
    },
    {
      title: 'E-Commerce Platform',
      description: 'Developed a full-stack e-commerce website with React.js frontend, RESTful API backend, and MySQL database. Implemented product listings, cart functionality, and user authentication.',
      tech: 'React.js, Node.js, MySQL, REST API',
      link: 'https://github.com/avidesai0110/Shoe_ecommerce_',
    },
  ];

  return (
    <section id="projects" className="projects">
      <div className="projects-container">
        <div className="section-label">SELECTED WORK</div>
        <h2 className="projects-heading">Selected Work</h2>
        <div className="projects-grid">
          {projects.map((project, index) => (
            <div key={index} className="project-card">
              <div className="project-tags">
                <span className="project-tag-dot"></span>
                <span className="project-tag">AI/ML</span>
              </div>
              <h3 className="project-title">{project.title}</h3>
              <p className="project-description">{project.description}</p>
              <div className="project-tech">
                <span className="tech-label">Tech:</span> {project.tech}
              </div>
              <a 
                href={project.link} 
                target="_blank" 
                rel="noopener noreferrer"
                className="project-link"
              >
                View details →
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
